(() => {
  const namespace = 'http://www.w3.org/2000/svg';
  const paths = {
    arrow:'M6 18 18 6M6 6h12v12',
    lock:'M6 10h12v11H6zM8 10V6a4 4 0 0 1 8 0v4',
    check:'m5 12 4 4L19 6',
    sparkle:'m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z',
    glass:'M5 4h14l-7 9-7-9Zm7 9v8m-4 0h8',
    truck:'M3 5h12v12H3zM15 9h4l3 4v4h-7M6 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
    envelope:'M3 5h18v14H3zM3 6l9 7 9-7',
    plus:'M12 4v16M4 12h16',
    heart:'M20 5c-3-3-6-1-8 1-2-2-5-4-8-1-4 4 1 10 8 15 7-5 12-11 8-15Z'
  };
  const map = new Map([[0x2197,'arrow'],[0x27a1,'arrow'],[0x1f512,'lock'],[0x1f513,'lock'],[0x1f69a,'truck'],[0x2705,'check'],[0x2714,'check'],[0x2728,'sparkle'],[0x1f942,'glass'],[0x1f378,'glass'],[0x1f379,'glass'],[0x1f4e7,'envelope'],[0x2709,'envelope'],[0x2795,'plus'],[0x2764,'heart']]);
  function replace(root) {
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode()) {
      const node=walker.currentNode;
      if(node.parentElement?.closest('script,style,textarea,input,select,svg,[contenteditable]'))continue;
      if([...node.textContent].some(char=>map.has(char.codePointAt(0))))nodes.push(node);
    }
    for(const node of nodes) {
      const fragment=document.createDocumentFragment();let text='';
      for(const char of node.textContent) {
        const code=char.codePointAt(0),kind=map.get(code);
        if(code===0xfe0f)continue;
        if(!kind){text+=char;continue;}
        if(text){fragment.append(document.createTextNode(text));text='';}
        const svg=document.createElementNS(namespace,'svg'),path=document.createElementNS(namespace,'path');
        Object.entries({viewBox:'0 0 24 24',width:'18',height:'18',fill:'none',stroke:'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}).forEach(([key,value])=>svg.setAttribute(key,value));
        svg.classList.add('ol-line-icon');svg.style.verticalAlign='middle';svg.style.flexShrink='0';path.setAttribute('d',paths[kind]);svg.append(path);fragment.append(svg);
      }
      if(text)fragment.append(document.createTextNode(text));node.replaceWith(fragment);
    }
  }
  const init=()=>{
    replace(document.body);
    new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1&&!node.matches('svg,path'))replace(node);}).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
